import React from 'react';
import { LoadingContainer } from './Loading.styles';

export function Loading() {
  return <LoadingContainer />;
}
